module.exports = __webpack_public_path__ + "img/gemnote-background.6d266f0e.png";